<app-template>
    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf=" isMobile === false && isTablet === false ">
        <div class="container-privacy">
            <div class="header-privacy">
                <h1><p>
                    CUMPLIMIENTO <br> JURÍDICO
                </p></h1>
            </div>
            <div class="privacy-content">
                <!-- <p class="date">
                  Fecha de última actualización: 24 de abril de 2018
                </p> -->
                <h2>
                    <p><span>FAD®</span> brinda total certeza jurídica para contrataciones y acuerdos</p>
                </h2>
                <p><span>FAD®</span> garantiza una implementación segura de acuerdo con:</p>
                <p>
                    Legalmente el proceso de <span>Firma Autógrafa Digital®</span> es válido ya que utiliza una serie de
                    elementos
                    preventivos y legales como son: una firma digitalizada y su rastro de formación, una huella de voz y
                    video con
                    su respectivo original como evidencia, incorpora una Constancia de Conservación emitida por un
                    Prestador de
                    Servicios de Certificación acreditado, y la vinculación con el dispositivo utilizado en el proceso,
                    formando
                    así una Huella de Auditoría, que podrá ser de gran valía a la vista del juzgador como conjunto
                    irrefutable de
                    evidencias.
                </p>
                <ul class="lines">
                    <li>- Código Federal de Procedimientos Civiles</li>
                    <li>- Código Civil Federal</li>
                    <li>- Código de Comercio</li>
                    <li>- Código Federal de Procedimientos Penales</li>
                    <li>- Ley Federal de Protección al Consumidor</li>
                    <li>- NOM 151 SCFI-2016</li>
                    <li>- Ley Federal del Trabajo</li>
                    <li>- Disposiciones Generales en materia de operaciones de sistemas de ahorro para el retiro</li>
                    <li>- Circular Única de Seguros y Fianzas</li>
                    <li>- Circular Única de Casas de Bolsa</li>
                    <li>- Circular Única de Bancos</li>
                    <li>- Circular Única de Operaciones CONSAR</li>
                    <li>- Ley Federal de Protección de Datos Personales en Posesión de los Particulares</li>
                </ul>
                <p class="title-section">
                    Marco Regulatorio
                </p>
                <p>
                    Las diversas reformas y adiciones a nuestro marco regulatorio civil y mercantil del año 2000 a la
                    fecha han
                    formado la base necesaria para el perfeccionamiento de una nueva manera de reconocer la celebración
                    de actos
                    jurídicos a través de nuevas tecnologías
                    Los documentos a citar que han tenido modificaciones son: Ley Federal de Procedimiento
                    Administrativo, Código
                    Civil Federal (CCF), Código Federal de Procedimientos Civiles (CFPC), Código de Comercio (CdC), Ley
                    Federal de
                    Protección al Consumidor, entre otros.
                </p>
                <p><span class="link higher">¡DESCARGA EL SUSTENTO LEGAL COMPLETO DE TU PAÍS!</span></p>
                <div class="sustento-pais">
                    <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('ARGENTINA')"><img src="assets/images/arg.png" alt=""></a>
                    <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('CHILE')"><img src="assets/images/chl.png" alt=""></a>
                    <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('COLOMBIA')"><img src="assets/images/clb.png" alt=""></a>
                    <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('ECUADOR')"><img src="assets/images/edr.png" alt=""></a>
                    <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('PANAMÁ')"><img src="assets/images/pnm.png" alt=""></a>
                    <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('BRASIL')"><img src="assets/images/brl.png" alt=""></a>
                    <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('BOLIVIA')"><img src="assets/images/blv.png" alt=""></a>
                    <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('COSTA RICA')"><img src="assets/images/cr.png" alt=""></a>
                    <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('PERÚ')"><img src="assets/images/pr.png" alt=""></a>
                    <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('EUA')"><img src="assets/images/usa.png" alt=""></a>
                    <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('MÉXICO')"><img src="assets/images/mex.png" alt=""></a>
                    <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('EU')"><img src="assets/images/ue.png" alt=""></a>
                </div>
                <p>
                    A manera de resumen se mencionan los cambios y definiciones más relevantes para los fines de la
                    <span>Firma Autógrafa Digital®</span>
                    en operaciones mercantiles:
                </p>
                <ol type="1">
                    <li>
                        Los documentos generados y firmados por medios de comunicación electrónica producen los mismos
                        efectos que
                        las leyes otorgan a los documentos firmados autógrafamente y, en consecuencia, tienen el mismo
                        valor
                        probatorio.
                    </li>
                    <li>
                        Reconocimiento de los “medios tecnológicos” (medios electrónicos, ópticos o de cualquier otra
                        tecnología),
                        como medio idóneo para expresar el consentimiento (CCF).
                    </li>
                    <li>
                        Establecimiento de una equivalencia funcional entre el consentimiento expresado por medios
                        tecnológicos y la
                        firma autógrafa cuando la información generada o comunicada en forma integral, a través de
                        dichos medios sea
                        atribuible a las personas obligadas y accesible para su ulterior consulta. Esta equivalencia se
                        da,
                        independientemente del tipo de documentos, mecanismos y medios empleados. (CCF)
                    </li>
                    <li>
                        Se reconoce como prueba, la información contenida en los medios tecnológicos. (CFPC)
                    </li>
                    <li>
                        Las reglas para su valoración por parte del juzgador: (1) La fiabilidad del método para generar,
                        comunicar,
                        recibir o archivar la información (deberá acreditarse que dicha información se ha mantenido
                        íntegra e
                        inalterada a partir del momento en que se generó por primera vez en su forma definitiva), (2) su
                        atribución
                        a las personas obligadas y (3) la posibilidad de acceder a ella en ulteriores consultas. (CFPC)
                    </li>
                    <li>
                        Disposición específica respecto a que los actos de comercio celebrados por medios electrónicos
                        se entienden
                        perfeccionados desde que se recibe la aceptación de la propuesta o las condiciones con que ésta
                        se modifique
                        (CdC)
                    </li>
                    <li>
                        Definición del concepto “Mensaje de Datos” como la información generada, enviada, recibida o
                        archivada a
                        través de medios electrónicos, ópticos o cualquier otra tecnología. (CdC)
                    </li>
                    <li>
                        Persistencia de la obligación a los comerciantes de conservar por un plazo mínimo de 10 años en
                        los mensajes
                        de datos o cualesquiera otros documentos que consignen convenios o compromisos que den
                        nacimiento a derechos
                        y obligaciones, manteniendo el contenido íntegro e inalterado a partir del momento en que se
                        generó y sea
                        accesible para su posterior consulta
                    </li>
                    <li>
                        Emisión de la Norma Oficial Mexicana que establece los requisitos que deberán observarse para la
                        conservación de mensajes de datos.
                    </li>
                    <li>
                        Reconocimiento de la utilización de medios electrónicos en la instrumentación de operaciones que
                        celebren
                        los proveedores con los consumidores, dando las bases sobre las cuales habrán de realizarse
                        dichas
                        operaciones: confidencialidad, certeza, seguridad en la información proporcionada al consumidor,
                        etc.
                        previendo sanciones al incumplimiento de dichas disposiciones.
                    </li>
                </ol>
                <p class="title-section">
                    Consideraciones
                </p>
                <p>
                    De lo anterior resulta necesario hacer las siguientes consideraciones para que un mensaje de datos
                    en el que
                    se consignen contratos o compromisos, pueda considerarse legalmente válido, es necesario asegurar
                    que la
                    información en él contenida reúna las siguientes características:
                </p>
                <ul class="lines">
                    <li>
                        <span>Accesibilidad: </span> Se refiere a que el contenido puede estar disponible al usuario
                        (emisor, juez,
                        auditor, autoridades, etc.) para una posterior consulta.
                    </li>
                    <li><span>Integridad: </span> Entendida en dos vertientes, (1) respecto a la fiabilidad del método
                        para
                        generar la información del documento firmado, comunicarla, recibirla o archivarla. (2) Como la
                        forma de
                        garantizar que la información contenida no fue alterada (NOM 151).
                    </li>
                    <li><span>Atribución: </span> Es la forma en la que podemos garantizar que las partes que se obligan
                        en la
                        relación jurídica son quienes dicen ser y expresan su voluntad libre de vicios.
                        Esta atribución a las personas obligadas en la relación jurídica que se pretende formalizar en
                        un mensaje de
                        datos, no es más que una firma electrónica que puede formarse usando medios de identificación o
                        a través de
                        un sistema de información programado por el emisor o en su nombre que opera automáticamente
                        (como puede ser
                        una cuenta de correo electrónico).
                        <br>
                        Importante – El medio físico del cual el contenido de un mensaje de datos se pone a disposición
                        del usuario
                        puede ser diferente
                        de aquél en que se creó, ya que se debe garantizar la integridad del mensaje de datos, no del
                        medio físico
                        que lo contiene.
                        Si requieres más información sobre el sustento legal de <span>FAD®</span>, por favor ponte en
                        contacto con
                        nosotros <span (click)="goTo('https://www.firmaautografa.com//contacto/')"
                                       class="link">aquí</span>.
                    </li>
                </ul>
            </div>
            <br>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">
        <div class="box-container">
            <div class="box-img">
                <img class="img-prin" src="assets/images/m/telefonos.png">
            </div>

            <div class="content-res">
                <h1>Cumplimiento legal</h1>
                <h2>
                    <p class="text"><span>FAD®</span> brinda total certeza jurídica para contrataciones y acuerdos</p>
                </h2>
                <p class="text"><span>FAD®</span> garantiza una implementación segura de acuerdo con:</p>
                <p class="text">
                    Legalmente el proceso de <span>Firma Autógrafa Digital®</span> es válido ya que utiliza una serie de
                    elementos
                    preventivos y legales como son: una firma digitalizada y su rastro de formación, una huella de voz y
                    video con
                    su respectivo original como evidencia, incorpora una Constancia de Conservación emitida por un
                    Prestador de
                    Servicios de Certificación acreditado, y la vinculación con el dispositivo utilizado en el proceso,
                    formando
                    así una Huella de Auditoría, que podrá ser de gran valía a la vista del juzgador como conjunto
                    irrefutable de
                    evidencias.
                </p>
                <ul class="lines text">
                    <li>Código Federal de Procedimientos Civiles</li>
                    <li>Código Civil Federal</li>
                    <li>Código de Comercio</li>
                    <li>Código Federal de Procedimientos Penales</li>
                    <li>Ley Federal de Protección al Consumidor</li>
                    <li>NOM 151 SCFI-2016</li>
                    <li>Ley Federal del Trabajo</li>
                    <li>Disposiciones Generales en materia de operaciones de sistemas de ahorro para el retiro</li>
                    <li>Circular Única de Seguros y Fianzas</li>
                    <li>Circular Única de Casas de Bolsa</li>
                    <li>Circular Única de Bancos</li>
                    <li>Circular Única de Operaciones CONSAR</li>
                    <li>Ley Federal de Protección de Datos Personales en Posesión de los Particulares</li>
                </ul>
                <p class="title-section">
                    Marco Regulatorio
                </p>
                <p class="text">
                    Las diversas reformas y adiciones a nuestro marco regulatorio civil y mercantil del año 2000 a la
                    fecha han
                    formado la base necesaria para el perfeccionamiento de una nueva manera de reconocer la celebración
                    de actos
                    jurídicos a través de nuevas tecnologías
                    Los documentos a citar que han tenido modificaciones son: Ley Federal de Procedimiento
                    Administrativo, Código
                    Civil Federal (CCF), Código Federal de Procedimientos Civiles (CFPC), Código de Comercio (CdC), Ley
                    Federal de
                    Protección al Consumidor, entre otros.
                </p>
                <p class="text"><span class="link higher">¡DESCARGA EL SUSTENTO LEGAL COMPLETO DE TU PAÍS!</span></p>
                    <div class="sustento-pais">
                        <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('ARGENTINA')"><img src="assets/images/arg.png" alt=""></a>
                        <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('CHILE')"><img src="assets/images/chl.png" alt=""></a>
                        <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('COLOMBIA')"><img src="assets/images/clb.png" alt=""></a>
                        <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('ECUADOR')"><img src="assets/images/edr.png" alt=""></a>
                        <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('PANAMÁ')"><img src="assets/images/pnm.png" alt=""></a>
                        <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('BRASIL')"><img src="assets/images/brl.png" alt=""></a>
                        <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('BOLIVIA')"><img src="assets/images/blv.png" alt=""></a>
                        <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('COSTA RICA')"><img src="assets/images/cr.png" alt=""></a>
                        <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('PERÚ')"><img src="assets/images/pr.png" alt=""></a>
                        <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('EUA')"><img src="assets/images/usa.png" alt=""></a>
                        <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('MÉXICO')"><img src="assets/images/mex.png" alt=""></a>
                        <a style="cursor: pointer" (click)="enviarDownloadCumplimiento('EU')"><img src="assets/images/ue.png" alt=""></a>
                    </div>
                <p class="text">
                    A manera de resumen se mencionan los cambios y definiciones más relevantes para los fines de la
                    <span>Firma Autógrafa Digital®</span>
                    en operaciones mercantiles:
                </p>
                <ol type="1" class="text">
                    <li>
                        Los documentos generados y firmados por medios de comunicación electrónica producen los mismos
                        efectos que
                        las leyes otorgan a los documentos firmados autógrafamente y, en consecuencia, tienen el mismo
                        valor
                        probatorio.
                    </li>
                    <li>
                        Reconocimiento de los “medios tecnológicos” (medios electrónicos, ópticos o de cualquier otra
                        tecnología),
                        como medio idóneo para expresar el consentimiento (CCF).
                    </li>
                    <li>
                        Establecimiento de una equivalencia funcional entre el consentimiento expresado por medios
                        tecnológicos y la
                        firma autógrafa cuando la información generada o comunicada en forma integral, a través de
                        dichos medios sea
                        atribuible a las personas obligadas y accesible para su ulterior consulta. Esta equivalencia se
                        da,
                        independientemente del tipo de documentos, mecanismos y medios empleados. (CCF)
                    </li>
                    <li>
                        Se reconoce como prueba, la información contenida en los medios tecnológicos. (CFPC)
                    </li>
                    <li>
                        Las reglas para su valoración por parte del juzgador: (1) La fiabilidad del método para generar,
                        comunicar,
                        recibir o archivar la información (deberá acreditarse que dicha información se ha mantenido
                        íntegra e
                        inalterada a partir del momento en que se generó por primera vez en su forma definitiva), (2) su
                        atribución
                        a las personas obligadas y (3) la posibilidad de acceder a ella en ulteriores consultas. (CFPC)
                    </li>
                    <li>
                        Disposición específica respecto a que los actos de comercio celebrados por medios electrónicos
                        se entienden
                        perfeccionados desde que se recibe la aceptación de la propuesta o las condiciones con que ésta
                        se modifique
                        (CdC)
                    </li>
                    <li>
                        Definición del concepto “Mensaje de Datos” como la información generada, enviada, recibida o
                        archivada a
                        través de medios electrónicos, ópticos o cualquier otra tecnología. (CdC)
                    </li>
                    <li>
                        Persistencia de la obligación a los comerciantes de conservar por un plazo mínimo de 10 años en
                        los mensajes
                        de datos o cualesquiera otros documentos que consignen convenios o compromisos que den
                        nacimiento a derechos
                        y obligaciones, manteniendo el contenido íntegro e inalterado a partir del momento en que se
                        generó y sea
                        accesible para su posterior consulta
                    </li>
                    <li>
                        Emisión de la Norma Oficial Mexicana que establece los requisitos que deberán observarse para la
                        conservación de mensajes de datos.
                    </li>
                    <li>
                        Reconocimiento de la utilización de medios electrónicos en la instrumentación de operaciones que
                        celebren
                        los proveedores con los consumidores, dando las bases sobre las cuales habrán de realizarse
                        dichas
                        operaciones: confidencialidad, certeza, seguridad en la información proporcionada al consumidor,
                        etc.
                        previendo sanciones al incumplimiento de dichas disposiciones.
                    </li>
                </ol>
                <p class="title-section">
                    Consideraciones
                </p>
                <p class="text">
                    De lo anterior resulta necesario hacer las siguientes consideraciones para que un mensaje de datos
                    en el que
                    se consignen contratos o compromisos, pueda considerarse legalmente válido, es necesario asegurar
                    que la
                    información en él contenida reúna las siguientes características:
                </p>
                <ul class="lines" class="text">
                    <li>
                        <span>Accesibilidad: </span> Se refiere a que el contenido puede estar disponible al usuario
                        (emisor, juez,
                        auditor, autoridades, etc.) para una posterior consulta.
                    </li>
                    <li><span>Integridad: </span> Entendida en dos vertientes, (1) respecto a la fiabilidad del método
                        para
                        generar la información del documento firmado, comunicarla, recibirla o archivarla. (2) Como la
                        forma de
                        garantizar que la información contenida no fue alterada (NOM 151).
                    </li>
                    <li><span>Atribución: </span> Es la forma en la que podemos garantizar que las partes que se obligan
                        en la
                        relación jurídica son quienes dicen ser y expresan su voluntad libre de vicios.
                        Esta atribución a las personas obligadas en la relación jurídica que se pretende formalizar en
                        un mensaje de
                        datos, no es más que una firma electrónica que puede formarse usando medios de identificación o
                        a través de
                        un sistema de información programado por el emisor o en su nombre que opera automáticamente
                        (como puede ser
                        una cuenta de correo electrónico).
                        <br>
                        Importante – El medio físico del cual el contenido de un mensaje de datos se pone a disposición
                        del usuario
                        puede ser diferente
                        de aquél en que se creó, ya que se debe garantizar la integridad del mensaje de datos, no del
                        medio físico
                        que lo contiene.
                        Si requieres más información sobre el sustento legal de <span>FAD®</span>, por favor ponte en
                        contacto con
                        nosotros <span (click)="goTo('https://www.firmaautografa.com//contacto/')"
                                       class="link">aquí</span>.
                    </li>
                </ul>
            </div>
        </div>
    </div>
</app-template>
